[
  {
    "id": "0",
    "name": {
      "fr": "Alphabet Cristallin",
      "en": "Cristal Alphabet",
      "es": "Alfabeto Cristalino"
    },
    "required": 10,
    "familyId": 0
  },
  {
    "id": "3",
    "name": {
      "fr": "Ballon de banquise",
      "en": "Beach Ball",
      "es": "Balón de playa"
    },
    "required": 10,
    "familyId": 0
  },
  {
    "id": "4",
    "name": {
      "fr": "Lampe Fétvoveu",
      "en": "Magic Lamp",
      "es": "Lámpara Pidedeseo"
    },
    "required": 10,
    "familyId": 0
  },
  {
    "id": "7",
    "name": {
      "fr": "Basket IcePump",
      "en": "Running Shoes",
      "es": "Botín IcePump"
    },
    "required": 10,
    "familyId": 0
  },
  {
    "id": "13",
    "name": {
      "fr": "Cass-Tet",
      "en": "Biker Helmet",
      "es": "Casco"
    },
    "required": 10,
    "familyId": 0
  },
  {
    "id": "21",
    "name": {
      "fr": "Enceinte Bessel-Son",
      "en": "Jukebox Igor",
      "es": "Altavoz Bájaloya"
    },
    "required": 10,
    "familyId": 0
  },
  {
    "id": "24",
    "name": {
      "fr": "Hippo-flocon",
      "en": "Iceberg Shower",
      "es": "Pedrusco de los montes"
    },
    "required": 10,
    "familyId": 0
  },
  {
    "id": "64",
    "name": {
      "fr": "Arc-en-miel",
      "en": "Honey Rainbow",
      "es": "Arcomiel"
    },
    "required": 10,
    "familyId": 0
  },
  {
    "id": "74",
    "name": {
      "fr": "Esprit de l'orange",
      "en": "Spirit of Orange",
      "es": "Espíritu de la naranja"
    },
    "required": 10,
    "familyId": 0
  },
  {
    "id": "77",
    "name": {
      "fr": "Lucidjané à crête bleue",
      "en": "Blue Crested Fish",
      "es": "Lucidjané con cresta azul"
    },
    "required": 10,
    "familyId": 0
  },
  {
    "id": "84",
    "name": {
      "fr": "Talisman scorpide",
      "en": "Scorpion Talisman",
      "es": "Talismán escorpión"
    },
    "required": 10,
    "familyId": 0
  },
  {
    "id": "102",
    "name": {
      "fr": "La Carotte d'Igor",
      "en": "Igor's Carrot",
      "es": "La Zanahoria de Igor"
    },
    "required": 1,
    "familyId": 0
  },
  {
    "id": "113",
    "name": {
      "fr": "Cape de Tuberculoz",
      "en": "The Robe of Tuber",
      "es": "Capa de Tubérculo"
    },
    "required": 10,
    "familyId": 0
  },
  {
    "id": "115",
    "name": {
      "fr": "Casque de Volleyfest",
      "en": "The Helmet of Volleyfest",
      "es": "Casco de Volleyfest"
    },
    "required": 10,
    "familyId": 0
  },
  {
    "id": "116",
    "name": {
      "fr": "Joyau d'Ankhel",
      "en": "The Ankhel Jewel",
      "es": "Joya de Ankhel"
    },
    "required": 10,
    "familyId": 0
  },
  {
    "id": "117",
    "name": {
      "fr": "Clé de Gordon",
      "en": "Gordon's Key",
      "es": "Llave de Gordon"
    },
    "required": 10,
    "familyId": 0
  },
  {
    "id": "1",
    "name": {
      "fr": "Bouclidur en or",
      "en": "Golden Shield",
      "es": "Escudo de madera y oro"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "5",
    "name": {
      "fr": "Lampe Léveussonfé",
      "en": "Black Magic Lam",
      "es": "Lámpara Negra"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "8",
    "name": {
      "fr": "Etoile des neiges",
      "en": "Gold Star",
      "es": "Estrella de las nieves"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "11",
    "name": {
      "fr": "Parapluie rouge",
      "en": "Red Umbrella",
      "es": "Paraguas rojo"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "18",
    "name": {
      "fr": "Pissenlit tropical",
      "en": "Tropical Dandelion",
      "es": "Flor tropical"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "22",
    "name": {
      "fr": "Vieille chaussure trouée",
      "en": "Heavy Weight Boots",
      "es": "Zapato viejo con agujeros"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "23",
    "name": {
      "fr": "Boule cristalline",
      "en": "Orb of Ice",
      "es": "Bola cristalina"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "25",
    "name": {
      "fr": "Flamme froide",
      "en": "Snow Flame",
      "es": "Llama fría"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "27",
    "name": {
      "fr": "Porte-grenouilles",
      "en": "Special Lilypad",
      "es": "Posa-ranas"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "28",
    "name": {
      "fr": "Bibelot en argent",
      "en": "Silver Trophy",
      "es": "Baratija de plata"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "38",
    "name": {
      "fr": "Totem des dinoz",
      "en": "Dino Totem Pole",
      "es": "Tótem de los Dinos"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "39",
    "name": {
      "fr": "Tête de granit lestée de plomb",
      "en": "Granite Easter Island",
      "es": "Cabeza de granito"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "65",
    "name": {
      "fr": "Bouée canard",
      "en": "Rubber Ducky",
      "es": "Flotador de pato"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "66",
    "name": {
      "fr": "Branche de Kipik",
      "en": "Magical Cactus",
      "es": "Rama de Kipik"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "69",
    "name": {
      "fr": "Koulraoule des îles",
      "en": "Turtle Islands",
      "es": "Tortuga de las islas"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "71",
    "name": {
      "fr": "Chaud devant !",
      "en": "Dragon's Breath",
      "es": "¡Emana calor!"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "82",
    "name": {
      "fr": "Jugement avant-dernier",
      "en": "Eye of Providence",
      "es": "Juicio penúltimo"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "106",
    "name": {
      "fr": "Livre des champignons",
      "en": "Book of Mushrooms",
      "es": "Libro de los hongos"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "107",
    "name": {
      "fr": "Livre des étoiles",
      "en": "Book of Stars",
      "es": "Libro de las estrellas"
    },
    "required": 10,
    "familyId": 1
  },
  {
    "id": "2",
    "name": {
      "fr": "Bouclidur argenté",
      "en": "Silver Shield",
      "es": "Escudo plateado"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "6",
    "name": {
      "fr": "Paix intérieure",
      "en": "Inner Peace",
      "es": "Paz interior"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "9",
    "name": {
      "fr": "Mauvais-oeil",
      "en": "Bad eye",
      "es": "Ojo malo"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "12",
    "name": {
      "fr": "Parapluie bleu",
      "en": "Blue Umbrella",
      "es": "Paraguas azul"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "19",
    "name": {
      "fr": "Tournelune",
      "en": "Explosive Sunflower",
      "es": "Giraluna"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "30",
    "name": {
      "fr": "Lunettes tournantes bleues",
      "en": "Blue Shades",
      "es": "Gafas volteadoras azules"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "31",
    "name": {
      "fr": "Lunettes renversantes rouges",
      "en": "Red Shades",
      "es": "Gafas revolteadoras rojas"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "36",
    "name": {
      "fr": "Ig'or",
      "en": "Golden Igor",
      "es": "Igoro"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "70",
    "name": {
      "fr": "Trêfle commun",
      "en": "Four-Leaf Clover",
      "es": "Trébol común"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "72",
    "name": {
      "fr": "Chapeau de Mage-Gris",
      "en": "Magician's Hat",
      "es": "Sombrero de Mago Gris"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "73",
    "name": {
      "fr": "Feuille de sinopée",
      "en": "Leaf",
      "es": "Hoja de árbol"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "75",
    "name": {
      "fr": "Esprit de la pluie",
      "en": "Spirit of Rain",
      "es": "Espíritu de la lluvia"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "76",
    "name": {
      "fr": "Esprit des arbres",
      "en": "Spirit of Trees",
      "es": "Espíritu de los árboles"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "80",
    "name": {
      "fr": "Escargot Poussépa",
      "en": "Snail Speed",
      "es": "Caracol Noempujes"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "81",
    "name": {
      "fr": "Perle nacrée des murlocs",
      "en": "Murloc's Pearl",
      "es": "Perla de nácar de los murlocs"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "86",
    "name": {
      "fr": "Surprise de paille",
      "en": "Ghost Candy",
      "es": "Sorpresa fantasmagórica"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "87",
    "name": {
      "fr": "Larve d'oenopterius",
      "en": "King Larvae",
      "es": "Larva de oenopterius"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "88",
    "name": {
      "fr": "Pokuté",
      "en": "Hare Nochi Guuuuu!",
      "es": "Pokuté"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "89",
    "name": {
      "fr": "Oeuf de Tzongre",
      "en": "Dragon Egg",
      "es": "Ojo de Tzongre"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "90",
    "name": {
      "fr": "Fulguro pieds-en-mousse",
      "en": "Slippery Bananas",
      "es": "Fulguro pies-pesados"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "93",
    "name": {
      "fr": "Boit'a'messages",
      "en": "Mail Box",
      "es": "Buzón zon"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "95",
    "name": {
      "fr": "Cagnotte de Tuberculoz",
      "en": "Tuber's Bag",
      "es": "Saco de Tubérculo"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "96",
    "name": {
      "fr": "Perle flamboyante",
      "en": "Flameberg Pearl",
      "es": "Perla flameante"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "99",
    "name": {
      "fr": "Poils de Chourou",
      "en": "Chourou's Hair",
      "es": "Pelos de Chourou"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "101",
    "name": {
      "fr": "Colis surprise",
      "en": "Surprise Package",
      "es": "Paquete sorpresa"
    },
    "required": 10,
    "familyId": 2
  },
  {
    "id": "112",
    "name": {
      "fr": "Pioupiou carnivore",
      "en": "Carnivorous PiouPiou",
      "es": "Píopío carnívoro"
    },
    "required": 1,
    "familyId": 2
  },
  {
    "id": "14",
    "name": {
      "fr": "Délice hallucinogène bleu",
      "en": "Blue Hallucinogenic Mushroom",
      "es": "Delicia alucinógena azul"
    },
    "required": 10,
    "familyId": 3
  },
  {
    "id": "15",
    "name": {
      "fr": "Champignon rigolo rouge",
      "en": "Red Delight Mushroom",
      "es": "Seta chuli y roja"
    },
    "required": 10,
    "familyId": 3
  },
  {
    "id": "16",
    "name": {
      "fr": "Figonassée grimpante",
      "en": "Green Beer Mushroom",
      "es": "Seta dorada trepadora"
    },
    "required": 10,
    "familyId": 3
  },
  {
    "id": "17",
    "name": {
      "fr": "Petit Waoulalu des bois",
      "en": "Golded Mushroom",
      "es": "Pequeña Walalu de los bosques"
    },
    "required": 10,
    "familyId": 3
  },
  {
    "id": "32",
    "name": {
      "fr": "As de pique",
      "en": "Ace of Spades",
      "es": "As de picas"
    },
    "required": 10,
    "familyId": 4
  },
  {
    "id": "33",
    "name": {
      "fr": "As de trêfle",
      "en": "Ace of Clubs",
      "es": "As de tréboles"
    },
    "required": 10,
    "familyId": 4
  },
  {
    "id": "34",
    "name": {
      "fr": "As de carreau",
      "en": "Ace of Diamonds",
      "es": "As de diamantes"
    },
    "required": 10,
    "familyId": 4
  },
  {
    "id": "35",
    "name": {
      "fr": "As de coeur",
      "en": "Ace of Hearts",
      "es": "As de corazones"
    },
    "required": 10,
    "familyId": 4
  },
  {
    "id": "40",
    "name": {
      "fr": "Sagittaire",
      "en": "Sagittarius",
      "es": "Sagitario"
    },
    "required": 1,
    "familyId": 5
  },
  {
    "id": "41",
    "name": {
      "fr": "Capricorne",
      "en": "Capricorn",
      "es": "Capricornio"
    },
    "required": 1,
    "familyId": 5
  },
  {
    "id": "42",
    "name": {
      "fr": "Lion",
      "en": "Leo",
      "es": "Leo"
    },
    "required": 1,
    "familyId": 5
  },
  {
    "id": "43",
    "name": {
      "fr": "Taureau",
      "en": "Taurus",
      "es": "Tauro"
    },
    "required": 1,
    "familyId": 5
  },
  {
    "id": "44",
    "name": {
      "fr": "Balance",
      "en": "Libra",
      "es": "Libra"
    },
    "required": 1,
    "familyId": 5
  },
  {
    "id": "45",
    "name": {
      "fr": "Bélier",
      "en": "Aries",
      "es": "Aries"
    },
    "required": 1,
    "familyId": 5
  },
  {
    "id": "46",
    "name": {
      "fr": "Scorpion",
      "en": "Scorpio",
      "es": "Escorpión"
    },
    "required": 1,
    "familyId": 5
  },
  {
    "id": "47",
    "name": {
      "fr": "Cancer",
      "en": "Cancer",
      "es": "Cáncer"
    },
    "required": 1,
    "familyId": 5
  },
  {
    "id": "48",
    "name": {
      "fr": "Verseau",
      "en": "Aquarius",
      "es": "Acuario"
    },
    "required": 1,
    "familyId": 5
  },
  {
    "id": "49",
    "name": {
      "fr": "Gémeaux",
      "en": "Gemini",
      "es": "Géminis"
    },
    "required": 1,
    "familyId": 5
  },
  {
    "id": "50",
    "name": {
      "fr": "Poisson",
      "en": "Pisces",
      "es": "Piscis"
    },
    "required": 1,
    "familyId": 5
  },
  {
    "id": "51",
    "name": {
      "fr": "Vierge",
      "en": "Virgo",
      "es": "Virgo"
    },
    "required": 1,
    "familyId": 5
  },
  {
    "id": "52",
    "name": {
      "fr": "Elixir du Sagittaire",
      "en": "Potion of Sagitarius",
      "es": "Elixir de Sagitario"
    },
    "required": 1,
    "familyId": 6
  },
  {
    "id": "53",
    "name": {
      "fr": "Elixir du Capricorne",
      "en": "Potion of Capricorn",
      "es": "Elixir de Capricornio"
    },
    "required": 1,
    "familyId": 6
  },
  {
    "id": "54",
    "name": {
      "fr": "Elixir du Lion",
      "en": "Potion of Leo",
      "es": "Elixir de Leo"
    },
    "required": 1,
    "familyId": 6
  },
  {
    "id": "55",
    "name": {
      "fr": "Elixir du Taureau",
      "en": "Potion of Taurus",
      "es": "Elixir de Tauro"
    },
    "required": 1,
    "familyId": 6
  },
  {
    "id": "56",
    "name": {
      "fr": "Elixir de la Balance",
      "en": "Potion of Libra",
      "es": "Elixir de Libra"
    },
    "required": 1,
    "familyId": 6
  },
  {
    "id": "57",
    "name": {
      "fr": "Elixir du Bélier",
      "en": "Potion of Aries",
      "es": "Elixir de Aries"
    },
    "required": 1,
    "familyId": 6
  },
  {
    "id": "58",
    "name": {
      "fr": "Elixir du Scorpion",
      "en": "Potion of Scorpio",
      "es": "Elixir de Escorpión"
    },
    "required": 1,
    "familyId": 6
  },
  {
    "id": "59",
    "name": {
      "fr": "Elixir du Cancer",
      "en": "Potion of Cancer",
      "es": "Elixir de Cáncer"
    },
    "required": 1,
    "familyId": 6
  },
  {
    "id": "60",
    "name": {
      "fr": "Elixir du Verseau",
      "en": "Potion of Aquarius",
      "es": "Elixir de Acuario"
    },
    "required": 1,
    "familyId": 6
  },
  {
    "id": "61",
    "name": {
      "fr": "Elixir des Gémeaux",
      "en": "Potion of Gemini",
      "es": "Elixir de Géminis"
    },
    "required": 1,
    "familyId": 6
  },
  {
    "id": "62",
    "name": {
      "fr": "Elixir du Poisson",
      "en": "Potion of Pisces",
      "es": "Elixir de Acuario"
    },
    "required": 1,
    "familyId": 6
  },
  {
    "id": "63",
    "name": {
      "fr": "Elixir de la Vierge",
      "en": "Potion of Virgo",
      "es": "Elixir de Virgo"
    },
    "required": 1,
    "familyId": 6
  },
  {
    "id": "103",
    "name": {
      "fr": "Vie palpitante",
      "en": "Wonderful Life!",
      "es": "Vida palpitante"
    },
    "required": 1,
    "familyId": 7
  },
  {
    "id": "104",
    "name": {
      "fr": "Vie aventureuse",
      "en": "Heart of an Adventurer",
      "es": "Vida aventurosa"
    },
    "required": 1,
    "familyId": 8
  },
  {
    "id": "105",
    "name": {
      "fr": "Vie épique",
      "en": "Final Destiny",
      "es": "Vida épica"
    },
    "required": 1,
    "familyId": 9
  },
  {
    "id": "20",
    "name": {
      "fr": "Coffre d'Anarchipel",
      "en": "Treasure Chest",
      "es": "Cofre de Anarchipiélago"
    },
    "required": 10,
    "familyId": 10
  },
  {
    "id": "78",
    "name": {
      "fr": "Filandreux rougeoyant",
      "en": "Flame Fish",
      "es": "Fibroso rojito"
    },
    "required": 10,
    "familyId": 10
  },
  {
    "id": "79",
    "name": {
      "fr": "Poisson empereur",
      "en": "Fish Emperor",
      "es": "Pez emperador"
    },
    "required": 10,
    "familyId": 10
  },
  {
    "id": "91",
    "name": {
      "fr": "Couvre-chef de Luffy",
      "en": "Luffy's Hat",
      "es": "Sombrero de paja de Luffy"
    },
    "required": 10,
    "familyId": 10
  },
  {
    "id": "94",
    "name": {
      "fr": "Anneau Antok",
      "en": "Antok Ring",
      "es": "Anillo Antok"
    },
    "required": 10,
    "familyId": 10
  },
  {
    "id": "83",
    "name": {
      "fr": "Jugement dernier",
      "en": "Final Judgment",
      "es": "Juicio final"
    },
    "required": 10,
    "familyId": 11
  },
  {
    "id": "97",
    "name": {
      "fr": "Perle vertillante",
      "en": "Green-Moss Pearl ",
      "es": "Perla verdeante"
    },
    "required": 10,
    "familyId": 11
  },
  {
    "id": "98",
    "name": {
      "fr": "Grosse pé-perle ",
      "en": "Super-Purple Pearl ",
      "es": "Gran pe-perla"
    },
    "required": 10,
    "familyId": 11
  },
  {
    "id": "100",
    "name": {
      "fr": "Pocket-Guu",
      "en": "Pocket-Guu",
      "es": "Guu de bolsillo"
    },
    "required": 10,
    "familyId": 11
  },
  {
    "id": "108",
    "name": {
      "fr": "Parapluie Frutiparc",
      "en": "Green Umbrella",
      "es": "Paraguas Frutiparc"
    },
    "required": 10,
    "familyId": 11
  },
  {
    "id": "29",
    "name": {
      "fr": "Bague 'Thermostat 8'",
      "en": "Ring of Fire",
      "es": "Anillo 'Termostato 8'"
    },
    "required": 10,
    "familyId": 12
  },
  {
    "id": "37",
    "name": {
      "fr": "Collier rafraîchissant",
      "en": "Necklace of Frost",
      "es": "Collar refrescante"
    },
    "required": 10,
    "familyId": 12
  },
  {
    "id": "67",
    "name": {
      "fr": "Anneau de Guillaume Tell",
      "en": "Ring of William Tell",
      "es": "Anillo de Omaíta"
    },
    "required": 10,
    "familyId": 12
  },
  {
    "id": "85",
    "name": {
      "fr": "Baton tonnerre",
      "en": "Hammer Time 3000",
      "es": "Martillo"
    },
    "required": 10,
    "familyId": 12
  },
  {
    "id": "92",
    "name": {
      "fr": "Chapeau violin",
      "en": "Chopper's Hat",
      "es": "Sombrero de Tony Tony Chopper"
    },
    "required": 10,
    "familyId": 12
  },
  {
    "id": "68",
    "name": {
      "fr": "Bougie",
      "en": "Candle of Light",
      "es": "Vela"
    },
    "required": 10,
    "familyId": 13
  },
  {
    "id": "26",
    "name": {
      "fr": "Ampoule 30 watts",
      "en": "Light Bulb",
      "es": "Bombilla 30 watios"
    },
    "required": 10,
    "familyId": 14
  },
  {
    "id": "109",
    "name": {
      "fr": "Flocon simple",
      "en": "Snowflake",
      "es": "Copo de nieve simple"
    },
    "required": 1,
    "familyId": 15
  },
  {
    "id": "110",
    "name": {
      "fr": "Flocon bizarre",
      "en": "Glacier",
      "es": "Copo de nieve raro"
    },
    "required": 1,
    "familyId": 16
  },
  {
    "id": "111",
    "name": {
      "fr": "Flocon ENORME !",
      "en": "Gon Ga Jora",
      "es": "Copo de nieve gigantesco"
    },
    "required": 1,
    "familyId": 17
  },
  {
    "id": "10",
    "name": {
      "fr": "Téléphone-phone-phone",
      "en": "Telephone",
      "es": "Teléfono-no-no"
    },
    "required": 5,
    "familyId": 18
  },
  {
    "id": "114",
    "name": {
      "fr": "Mode Mario",
      "en": "Mario Mode!",
      "es": "Modo Mario"
    },
    "required": 10,
    "familyId": 19
  },
  {
    "id": "1000",
    "name": {
      "fr": "Cristaux d'Hammerfest",
      "en": "Hammerfest Crystal",
      "es": "Cristales de Hammerfest"
    },
    "required": 10,
    "familyId": 1000
  },
  {
    "id": "1003",
    "name": {
      "fr": "Bonbon Berlinmauve",
      "en": "Seed Candy",
      "es": "Caramelo Berlinmalva"
    },
    "required": 10,
    "familyId": 1000
  },
  {
    "id": "1008",
    "name": {
      "fr": "Diamant Oune-difaïned",
      "en": "Difaïned Diamond",
      "es": "Diamante difaïned"
    },
    "required": 10,
    "familyId": 1000
  },
  {
    "id": "1013",
    "name": {
      "fr": "Muffin aux cailloux",
      "en": "Muffin",
      "es": "Magdalena de piedras"
    },
    "required": 10,
    "familyId": 1000
  },
  {
    "id": "1017",
    "name": {
      "fr": "Pierres du Changement",
      "en": "Magical Stones",
      "es": "Piedras del Cambio"
    },
    "required": 10,
    "familyId": 1000
  },
  {
    "id": "1027",
    "name": {
      "fr": "Réglisse rouge",
      "en": "Red Licorice",
      "es": "Chuchería"
    },
    "required": 10,
    "familyId": 1000
  },
  {
    "id": "1041",
    "name": {
      "fr": "Sucette acidulée",
      "en": "Lollipop",
      "es": "Piruleta"
    },
    "required": 10,
    "familyId": 1000
  },
  {
    "id": "1043",
    "name": {
      "fr": "Sorbet au plastique",
      "en": "Plastic Sorbet",
      "es": "Polo de plástico"
    },
    "required": 10,
    "familyId": 1000
  },
  {
    "id": "1047",
    "name": {
      "fr": "Bleuet",
      "en": "Sapphire Mushroom",
      "es": "Seta azulada"
    },
    "required": 10,
    "familyId": 1000
  },
  {
    "id": "1048",
    "name": {
      "fr": "Rougeoyant",
      "en": "Ruby Mushroom",
      "es": "Rojeante"
    },
    "required": 10,
    "familyId": 1000
  },
  {
    "id": "1049",
    "name": {
      "fr": "Verdifiant",
      "en": "Emerald Mushroom",
      "es": "Verdifiante"
    },
    "required": 10,
    "familyId": 1000
  },
  {
    "id": "1050",
    "name": {
      "fr": "KassDent",
      "en": "Sliver Mushroom",
      "es": "Rompedientes"
    },
    "required": 10,
    "familyId": 1000
  },
  {
    "id": "1051",
    "name": {
      "fr": "Pièce d'or secrète",
      "en": "Secret Coin",
      "es": "Moneda de oro secreta"
    },
    "required": 10,
    "familyId": 1000
  },
  {
    "id": "1169",
    "name": {
      "fr": "Etoile Toulaho",
      "en": "Starfish",
      "es": "Estrella Toulaho"
    },
    "required": 10,
    "familyId": 1000
  },
  {
    "id": "1185",
    "name": {
      "fr": "Anneau hérissé",
      "en": "Bristling Ring",
      "es": "Anillo de erizo azul"
    },
    "required": 10,
    "familyId": 1000
  },
  {
    "id": "1022",
    "name": {
      "fr": "Liquide bizarre",
      "en": "Bizarre Liquid",
      "es": "Líquido raro"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1024",
    "name": {
      "fr": "Liquide étrange",
      "en": "Strange Liquid",
      "es": "Líquido extraño"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1025",
    "name": {
      "fr": "Oeuf cru",
      "en": "Raw Egg",
      "es": "Huevo crudo"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1026",
    "name": {
      "fr": "Gland gnan-gnan",
      "en": "Potato",
      "es": "Gran ñan-ñan"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1028",
    "name": {
      "fr": "Oeuf Au Plat",
      "en": "Plain Egg",
      "es": "Huevo frito"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1040",
    "name": {
      "fr": "Sushi thon",
      "en": "Fish Sushi",
      "es": "Sushi de atún"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1069",
    "name": {
      "fr": "Cacahuete secrète",
      "en": "Peanut",
      "es": "Cacahuete secreto"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1070",
    "name": {
      "fr": "P'tit fantome",
      "en": "Small Ghost",
      "es": "Fantasmita"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1071",
    "name": {
      "fr": "Cookie deshydraté",
      "en": "Hard Cookie",
      "es": "Cookie deshidratada"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1073",
    "name": {
      "fr": "Piment farceur",
      "en": "Hot Pepper",
      "es": "Pimiento del piquillo"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1074",
    "name": {
      "fr": "Soja Max IceCream",
      "en": "Bread",
      "es": "Helado de Soja Max"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1075",
    "name": {
      "fr": "Bouquet de steack",
      "en": "Bouquet",
      "es": "Ramo de carne"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1077",
    "name": {
      "fr": "Graine de tournesol",
      "en": "Grain",
      "es": "Semilla de girasol"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1078",
    "name": {
      "fr": "Croissant confit",
      "en": "Croissant",
      "es": "Croissant confitado"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1079",
    "name": {
      "fr": "Haricot paresseux",
      "en": "Beans",
      "es": "Judía perezosa"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1080",
    "name": {
      "fr": "Lapin-choco",
      "en": "Chocolate Bunny",
      "es": "Conejo de chocolate"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1081",
    "name": {
      "fr": "Biloo",
      "en": "Beer",
      "es": "Hidromiel de los Bosques"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1082",
    "name": {
      "fr": "Graine de pechume en gelée",
      "en": "Jelly with Corn",
      "es": "Gota viscosa"
    },
    "required": 10,
    "familyId": 1001
  },
  {
    "id": "1002",
    "name": {
      "fr": "Canne de Bobble",
      "en": "Candy Cane",
      "es": "Bastón de Bobble"
    },
    "required": 10,
    "familyId": 1002
  },
  {
    "id": "1004",
    "name": {
      "fr": "Bonbon Chamagros",
      "en": "Raindrop Candy",
      "es": "Caramelo Chamagros"
    },
    "required": 10,
    "familyId": 1002
  },
  {
    "id": "1005",
    "name": {
      "fr": "Bonbon rosamelle-praline",
      "en": "Cherry Candy",
      "es": "Caramelo rosa-praliné"
    },
    "required": 10,
    "familyId": 1002
  },
  {
    "id": "1006",
    "name": {
      "fr": "Sucette aux fruits bleus",
      "en": "Blue Raspberry Lollipop",
      "es": "Chupakups de frutas azules"
    },
    "required": 10,
    "familyId": 1002
  },
  {
    "id": "1007",
    "name": {
      "fr": "Sucette chlorophylle",
      "en": "Green Apple Lollipop",
      "es": "Chupakups de clorofila"
    },
    "required": 10,
    "familyId": 1002
  },
  {
    "id": "1012",
    "name": {
      "fr": "Surprise de Cerises",
      "en": "Surprise Cake",
      "es": "Sorpresa de Cerezas"
    },
    "required": 10,
    "familyId": 1002
  },
  {
    "id": "1014",
    "name": {
      "fr": "Gelée des bois",
      "en": "Cake",
      "es": "Pastel de madera"
    },
    "required": 10,
    "familyId": 1002
  },
  {
    "id": "1015",
    "name": {
      "fr": "Suprême aux framboises",
      "en": "Wedding Cake",
      "es": "Tarta suprema de frambuesas"
    },
    "required": 10,
    "familyId": 1002
  },
  {
    "id": "1016",
    "name": {
      "fr": "Petit pétillant",
      "en": "Piece of Cake",
      "es": "Tarta muy rica"
    },
    "required": 10,
    "familyId": 1002
  },
  {
    "id": "1018",
    "name": {
      "fr": "Glace Fraise",
      "en": "Strawberry Ice Cream",
      "es": "Helado de fresa"
    },
    "required": 10,
    "familyId": 1002
  },
  {
    "id": "1019",
    "name": {
      "fr": "Coupe Glacée",
      "en": "Ice Cream Cup",
      "es": "Copa helada"
    },
    "required": 10,
    "familyId": 1002
  },
  {
    "id": "1023",
    "name": {
      "fr": "Gros acidulé",
      "en": "Taffy",
      "es": "Gran azucarado"
    },
    "required": 10,
    "familyId": 1002
  },
  {
    "id": "1045",
    "name": {
      "fr": "Pétale mystérieuse",
      "en": "Cashew",
      "es": "Pétalo misterioso"
    },
    "required": 10,
    "familyId": 1002
  },
  {
    "id": "1046",
    "name": {
      "fr": "Gump",
      "en": "Gump",
      "es": "Gump"
    },
    "required": 10,
    "familyId": 1002
  },
  {
    "id": "1009",
    "name": {
      "fr": "Oeil de tigre",
      "en": "Eye of the Tiger",
      "es": "Ojo del Tigre"
    },
    "required": 10,
    "familyId": 1003
  },
  {
    "id": "1010",
    "name": {
      "fr": "Jade de 12kg",
      "en": "12kg Jade",
      "es": "Jade de 12kg"
    },
    "required": 10,
    "familyId": 1003
  },
  {
    "id": "1011",
    "name": {
      "fr": "Reflet-de-lune",
      "en": "Moon Glade",
      "es": "Reflejo-de-luna"
    },
    "required": 10,
    "familyId": 1003
  },
  {
    "id": "1001",
    "name": {
      "fr": "Pain à la viande",
      "en": "Hamburger",
      "es": "Pan de carne"
    },
    "required": 10,
    "familyId": 1004
  },
  {
    "id": "1021",
    "name": {
      "fr": "Poulet Surgelé",
      "en": "Frozen Chicken",
      "es": "Pollo congelado"
    },
    "required": 10,
    "familyId": 1004
  },
  {
    "id": "1042",
    "name": {
      "fr": "Délice d'Aralé",
      "en": "Chocolate Mousse",
      "es": "Delicia de Arale"
    },
    "required": 10,
    "familyId": 1004
  },
  {
    "id": "1055",
    "name": {
      "fr": "Boisson kipik",
      "en": "Soda",
      "es": "Bebida kipik"
    },
    "required": 10,
    "familyId": 1004
  },
  {
    "id": "1056",
    "name": {
      "fr": "Doigts-de-tuberculoz",
      "en": "French Fries",
      "es": "Dedos-de-Tubérculo"
    },
    "required": 10,
    "familyId": 1004
  },
  {
    "id": "1057",
    "name": {
      "fr": "Pizza de Donatello",
      "en": "Slice of Pizza",
      "es": "Pizza de Donatello"
    },
    "required": 10,
    "familyId": 1004
  },
  {
    "id": "1142",
    "name": {
      "fr": "Café de fin de projet",
      "en": "Project Finisher",
      "es": "Café de fin de proyecto"
    },
    "required": 10,
    "familyId": 1004
  },
  {
    "id": "1149",
    "name": {
      "fr": "Noodles crus",
      "en": "Ramen Noodles",
      "es": "Fideos chinos deshidratados"
    },
    "required": 10,
    "familyId": 1004
  },
  {
    "id": "1166",
    "name": {
      "fr": "Oeuf de Poire",
      "en": "Pear Egg",
      "es": "Huevo de pera"
    },
    "required": 10,
    "familyId": 1004
  },
  {
    "id": "1020",
    "name": {
      "fr": "Noodles",
      "en": "Noodles",
      "es": "Fideos chinos"
    },
    "required": 10,
    "familyId": 1005
  },
  {
    "id": "1039",
    "name": {
      "fr": "Monsieur radis",
      "en": "Mr. Radish",
      "es": "Señor rábano"
    },
    "required": 10,
    "familyId": 1005
  },
  {
    "id": "1044",
    "name": {
      "fr": "Manda",
      "en": "Manda",
      "es": "Manda"
    },
    "required": 10,
    "familyId": 1005
  },
  {
    "id": "1060",
    "name": {
      "fr": "Bleuette rouge",
      "en": "Red Plant",
      "es": "Nadie sabe lo que es"
    },
    "required": 10,
    "familyId": 1005
  },
  {
    "id": "1061",
    "name": {
      "fr": "Perroquet décapité en sauce",
      "en": "Parrot Head",
      "es": "Loro decapitado en salsa"
    },
    "required": 10,
    "familyId": 1005
  },
  {
    "id": "1062",
    "name": {
      "fr": "Morvo-morphe",
      "en": "Alien Blob",
      "es": "Morvo-morfo"
    },
    "required": 10,
    "familyId": 1005
  },
  {
    "id": "1076",
    "name": {
      "fr": "Daruma-Pastèque",
      "en": "Daruma Watermelon",
      "es": "Daruma-Sandía"
    },
    "required": 10,
    "familyId": 1005
  },
  {
    "id": "1161",
    "name": {
      "fr": "Nem aux anchois",
      "en": "Breaded Anchovies",
      "es": "Nem de anchoas"
    },
    "required": 10,
    "familyId": 1005
  },
  {
    "id": "1162",
    "name": {
      "fr": "Surimi pamplemousse",
      "en": "Grapefruit Sushi",
      "es": "Surimi de pomelo"
    },
    "required": 10,
    "familyId": 1005
  },
  {
    "id": "1163",
    "name": {
      "fr": "Poulpi à l'encre",
      "en": "Octopus in Ink",
      "es": "Calamar en su tinta"
    },
    "required": 10,
    "familyId": 1005
  },
  {
    "id": "1167",
    "name": {
      "fr": "Truffe collante sans goût",
      "en": "Tasteless Sticky Truffle",
      "es": "Trufa pegajosa sin sabor"
    },
    "required": 10,
    "familyId": 1005
  },
  {
    "id": "1029",
    "name": {
      "fr": "Saucisse piquée",
      "en": "Sausage on a Stick",
      "es": "Salchica con palillo de dientes"
    },
    "required": 10,
    "familyId": 1006
  },
  {
    "id": "1030",
    "name": {
      "fr": "Cerise-apéro confite",
      "en": "Cherry on a Stick",
      "es": "Cereza con palillo de dientes"
    },
    "required": 10,
    "familyId": 1006
  },
  {
    "id": "1031",
    "name": {
      "fr": "Fromage piqué",
      "en": "Cheese on a Stick",
      "es": "Queso con palillo de dientes"
    },
    "required": 10,
    "familyId": 1006
  },
  {
    "id": "1032",
    "name": {
      "fr": "Olive pas mûre",
      "en": "Green Olive on a Stick",
      "es": "Aceituna de Estepa"
    },
    "required": 10,
    "familyId": 1006
  },
  {
    "id": "1033",
    "name": {
      "fr": "Olive noire",
      "en": "Black Olive on a Stick",
      "es": "Aceituna negra de Estepa"
    },
    "required": 10,
    "familyId": 1006
  },
  {
    "id": "1034",
    "name": {
      "fr": "Oeil de pomme",
      "en": "Eyeball on a Stick",
      "es": "Ojo del cochino"
    },
    "required": 10,
    "familyId": 1006
  },
  {
    "id": "1035",
    "name": {
      "fr": "Blob intrusif",
      "en": "Jello on a Stick",
      "es": "Aperitivo de Blandiblú"
    },
    "required": 10,
    "familyId": 1006
  },
  {
    "id": "1036",
    "name": {
      "fr": "Gouda mou",
      "en": "Gouda on a Stick",
      "es": "Queso holandés blando"
    },
    "required": 10,
    "familyId": 1006
  },
  {
    "id": "1037",
    "name": {
      "fr": "Poulpi empalé",
      "en": "Fish on a Stick",
      "es": "Tapa de calamar"
    },
    "required": 10,
    "familyId": 1006
  },
  {
    "id": "1038",
    "name": {
      "fr": "Olive oubliée",
      "en": "Stuffed Olive on a Stick",
      "es": "Aceituna olvidada"
    },
    "required": 10,
    "familyId": 1006
  },
  {
    "id": "1164",
    "name": {
      "fr": "Curly",
      "en": "Curly",
      "es": "Curly"
    },
    "required": 10,
    "familyId": 1006
  },
  {
    "id": "1052",
    "name": {
      "fr": "Sou d'argent",
      "en": "Silver Coin",
      "es": "Moneda de plata"
    },
    "required": 10,
    "familyId": 1007
  },
  {
    "id": "1053",
    "name": {
      "fr": "Sou d'or",
      "en": "Gold Coin",
      "es": "Moneda de oro"
    },
    "required": 10,
    "familyId": 1007
  },
  {
    "id": "1054",
    "name": {
      "fr": "Gros tas de sous",
      "en": "Big Unemployment",
      "es": "Un montón de dinero"
    },
    "required": 10,
    "familyId": 1007
  },
  {
    "id": "1091",
    "name": {
      "fr": "Jambon de Bayonne",
      "en": "Raw Ham",
      "es": "Jamón"
    },
    "required": 10,
    "familyId": 1008
  },
  {
    "id": "1092",
    "name": {
      "fr": "Saucisson entamé",
      "en": "Sliced Sausage",
      "es": "Lomo embuchado de jabugo"
    },
    "required": 10,
    "familyId": 1008
  },
  {
    "id": "1093",
    "name": {
      "fr": "Raide red reste",
      "en": "Red Remains",
      "es": "Mortadela torcida"
    },
    "required": 10,
    "familyId": 1008
  },
  {
    "id": "1094",
    "name": {
      "fr": "Torchon madrangeais au sirop d'érable",
      "en": "Maple Syrup Roll",
      "es": "Bacon al sirope de fresa"
    },
    "required": 10,
    "familyId": 1008
  },
  {
    "id": "1095",
    "name": {
      "fr": "Saucisson de marcassin sauvage",
      "en": "Blood Sausage",
      "es": "Salchichón de jabato salvaje"
    },
    "required": 10,
    "familyId": 1008
  },
  {
    "id": "1096",
    "name": {
      "fr": "Tranches de Jaret de Kangourou",
      "en": "Kangaroo Liver",
      "es": "Rebanada de Canguro"
    },
    "required": 10,
    "familyId": 1008
  },
  {
    "id": "1097",
    "name": {
      "fr": "Saucissaille de St-Morgelet",
      "en": "Sausage of St.Morgelet",
      "es": "Salchichón de la Sierra de Aracena"
    },
    "required": 10,
    "familyId": 1008
  },
  {
    "id": "1098",
    "name": {
      "fr": "Paté d'ongles au truffes",
      "en": "Head Cheese",
      "es": "Pavo trufado sin cabello de ángel"
    },
    "required": 10,
    "familyId": 1008
  },
  {
    "id": "1099",
    "name": {
      "fr": "Saucisson maudit scellé",
      "en": "Squished Sausage",
      "es": "Salchichón maldito"
    },
    "required": 10,
    "familyId": 1008
  },
  {
    "id": "1063",
    "name": {
      "fr": "Fraise Tagada",
      "en": "Tagada-Strawberry",
      "es": "Chuchería de fresa"
    },
    "required": 10,
    "familyId": 1009
  },
  {
    "id": "1064",
    "name": {
      "fr": "Car-En-Sac",
      "en": "Car-En-Sac",
      "es": "Píldoras de mentira"
    },
    "required": 10,
    "familyId": 1009
  },
  {
    "id": "1065",
    "name": {
      "fr": "Dragibus",
      "en": "Dragibus",
      "es": "Bolitas de chuches"
    },
    "required": 10,
    "familyId": 1009
  },
  {
    "id": "1066",
    "name": {
      "fr": "Krokodile",
      "en": "Crocodile",
      "es": "Chuchería de cocodrilo"
    },
    "required": 10,
    "familyId": 1009
  },
  {
    "id": "1067",
    "name": {
      "fr": "Demi Cocobats",
      "en": "Half Cocobats",
      "es": "Chuche de infancia irlandesa"
    },
    "required": 10,
    "familyId": 1009
  },
  {
    "id": "1068",
    "name": {
      "fr": "Happy Cola",
      "en": "Happy Cola",
      "es": "Una botellita de cola"
    },
    "required": 10,
    "familyId": 1009
  },
  {
    "id": "1083",
    "name": {
      "fr": "Sombrino aux amandes",
      "en": "Chocolate with Almond",
      "es": "Bombón de nueces"
    },
    "required": 10,
    "familyId": 1010
  },
  {
    "id": "1084",
    "name": {
      "fr": "Emi-Praline",
      "en": "Dark Chocolate",
      "es": "Emi-Praliné"
    },
    "required": 10,
    "familyId": 1010
  },
  {
    "id": "1085",
    "name": {
      "fr": "Frogmaliet aux pepites de chocolat",
      "en": "Belgium Chocolate",
      "es": "Bombón con pepitas de chocolate"
    },
    "required": 10,
    "familyId": 1010
  },
  {
    "id": "1086",
    "name": {
      "fr": "Yumi au café",
      "en": "White Chocolate with Coffee Bean",
      "es": "Yumi de café"
    },
    "required": 10,
    "familyId": 1010
  },
  {
    "id": "1087",
    "name": {
      "fr": "Bouchée mielleuse nappée au gel de Vodka",
      "en": "Vodka Chocolate",
      "es": "Esponjita de gel de Vodka"
    },
    "required": 10,
    "familyId": 1010
  },
  {
    "id": "1088",
    "name": {
      "fr": "Escargot au chocolat persillé",
      "en": "Snail Chocolate",
      "es": "Caracol de chocolate de pasta de queso"
    },
    "required": 10,
    "familyId": 1010
  },
  {
    "id": "1089",
    "name": {
      "fr": "Fossile de cacao marbré au fois gras",
      "en": "Marble Chocolate",
      "es": "Fósil de chocolate de márbol de foie gras"
    },
    "required": 10,
    "familyId": 1010
  },
  {
    "id": "1090",
    "name": {
      "fr": "Cerisot mariné a la bière",
      "en": "Cerisot Marinated in Beer",
      "es": "Caramelo marinado a la cerveza"
    },
    "required": 10,
    "familyId": 1010
  },
  {
    "id": "1106",
    "name": {
      "fr": "Camembert",
      "en": "Mozzarella Cheese",
      "es": "Camembert"
    },
    "required": 10,
    "familyId": 1011
  },
  {
    "id": "1107",
    "name": {
      "fr": "Emmental",
      "en": "Emmental Cheese",
      "es": "Emmental"
    },
    "required": 10,
    "familyId": 1011
  },
  {
    "id": "1108",
    "name": {
      "fr": "Fromage verni",
      "en": "Edam Cheese",
      "es": "Queso barnizado"
    },
    "required": 10,
    "familyId": 1011
  },
  {
    "id": "1109",
    "name": {
      "fr": "Roquefort",
      "en": "Blue Cheese",
      "es": "Roquefort"
    },
    "required": 10,
    "familyId": 1011
  },
  {
    "id": "1110",
    "name": {
      "fr": "Fromage frais vigné",
      "en": "Swiss Cheese",
      "es": "Queso fresco"
    },
    "required": 10,
    "familyId": 1011
  },
  {
    "id": "1111",
    "name": {
      "fr": "Pâte dessert fromagée",
      "en": "Cheesecake",
      "es": "Quesito"
    },
    "required": 10,
    "familyId": 1011
  },
  {
    "id": "1100",
    "name": {
      "fr": "Manquereau-sauce-au-citron",
      "en": "Lemon Canned-Fish",
      "es": "Lata de atún en aceite de oliva"
    },
    "required": 10,
    "familyId": 1012
  },
  {
    "id": "1101",
    "name": {
      "fr": "Mini-saucisses en boite",
      "en": "Canned Sliced Sausages",
      "es": "Minisalchichas en conserva"
    },
    "required": 10,
    "familyId": 1012
  },
  {
    "id": "1102",
    "name": {
      "fr": "Haricots blanc",
      "en": "White Beans",
      "es": "Judías blancas"
    },
    "required": 10,
    "familyId": 1012
  },
  {
    "id": "1103",
    "name": {
      "fr": "Lychees premier prix",
      "en": "Canned Lychees",
      "es": "Litchis incaducables"
    },
    "required": 10,
    "familyId": 1012
  },
  {
    "id": "1104",
    "name": {
      "fr": "Zion's Calamar",
      "en": "Zion's Cheese",
      "es": "Fabada asturiana en conserva"
    },
    "required": 10,
    "familyId": 1012
  },
  {
    "id": "1105",
    "name": {
      "fr": "Aubergines au sirop",
      "en": "Pâté",
      "es": "Conserva de lentejas madrileñas con chorizo"
    },
    "required": 10,
    "familyId": 1012
  },
  {
    "id": "1168",
    "name": {
      "fr": "Sardines",
      "en": "Sardines",
      "es": "Sardinas en lata"
    },
    "required": 10,
    "familyId": 1012
  },
  {
    "id": "1112",
    "name": {
      "fr": "Saladou",
      "en": "Lettuce",
      "es": "Ensalado"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1113",
    "name": {
      "fr": "Poire d'eau",
      "en": "Leek",
      "es": "Puerro de agua"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1114",
    "name": {
      "fr": "Cacahuète mauve et juteuse",
      "en": "Eggplant",
      "es": "Cacahuete aceitoso de malva"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1115",
    "name": {
      "fr": "Pommes de pierre",
      "en": "Walnut",
      "es": "Manzana de piedra"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1116",
    "name": {
      "fr": "Patates douces",
      "en": "Hazelnut",
      "es": "Patatas dulces"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1117",
    "name": {
      "fr": "Matraque bio",
      "en": "Cucumber",
      "es": "Porra bio"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1118",
    "name": {
      "fr": "Tomate pacifique",
      "en": "Tomato",
      "es": "Tomate pacífico"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1119",
    "name": {
      "fr": "Radix",
      "en": "Radish",
      "es": "Rabanox"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1120",
    "name": {
      "fr": "Haricots verts",
      "en": "Green Beans",
      "es": "Judías verdes"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1121",
    "name": {
      "fr": "Pomme Sapik",
      "en": "Onion",
      "es": "Cebolla Sapik"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1122",
    "name": {
      "fr": "Pomme Sapu",
      "en": "Garlic",
      "es": "Ajos Sapu"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1123",
    "name": {
      "fr": "Echalottes",
      "en": "Shallots",
      "es": "Chalote"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1124",
    "name": {
      "fr": "Sel rieur",
      "en": "River Salt",
      "es": "Sal que ríe"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1125",
    "name": {
      "fr": "Poivron vert",
      "en": "Green Pepper",
      "es": "Pimiento verde"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1126",
    "name": {
      "fr": "Poivron jaune",
      "en": "Yellow Pepper",
      "es": "Pimiento amarillo"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1127",
    "name": {
      "fr": "Poivron rouge",
      "en": "Red Pepper",
      "es": "Pimiento rojo"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1128",
    "name": {
      "fr": "Brocolis digérés",
      "en": "Digested Broccoli",
      "es": "Brocolis digerido"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1129",
    "name": {
      "fr": "Grappe de Radix",
      "en": "Bitten Radish",
      "es": "Rácimo de Rabanox"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1130",
    "name": {
      "fr": "Lance-poix",
      "en": "Snow Peas",
      "es": "Lanza-guisantes"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1131",
    "name": {
      "fr": "Haricots blancs",
      "en": "White Beans",
      "es": "Judías blancas"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1132",
    "name": {
      "fr": "Poires d'eau en grappe",
      "en": "Blended Pears",
      "es": "Puñado de puerros de agua"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1133",
    "name": {
      "fr": "Artifroid",
      "en": "Artichoke",
      "es": "Alcachofa"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1134",
    "name": {
      "fr": "Choux-flou",
      "en": "Cauliflower",
      "es": "Coliflor"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1135",
    "name": {
      "fr": "Chourou",
      "en": "Purple Cabbage",
      "es": "Lombarda"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1136",
    "name": {
      "fr": "Pom pom pom..",
      "en": "Corn",
      "es": "Disparador de Maíz"
    },
    "required": 10,
    "familyId": 1013
  },
  {
    "id": "1141",
    "name": {
      "fr": "Brioche dorée",
      "en": "Golden Pastry",
      "es": "Magdalena brioche"
    },
    "required": 10,
    "familyId": 1014
  },
  {
    "id": "1143",
    "name": {
      "fr": "Laxatif aux amandes",
      "en": "Almond Laxative",
      "es": "Laxante de almendras"
    },
    "required": 10,
    "familyId": 1014
  },
  {
    "id": "1137",
    "name": {
      "fr": "Hollandais",
      "en": "Dutch Cake",
      "es": "Sandwich tostado Holandés"
    },
    "required": 10,
    "familyId": 1015
  },
  {
    "id": "1138",
    "name": {
      "fr": "Fondant XXL au choco-beurre",
      "en": "Chocolate Fudge Cake",
      "es": "Pastel XXL de choco-mantequilla"
    },
    "required": 10,
    "familyId": 1015
  },
  {
    "id": "1139",
    "name": {
      "fr": "Pétillante",
      "en": "Sparkling Soda",
      "es": "Gaseosa"
    },
    "required": 10,
    "familyId": 1015
  },
  {
    "id": "1140",
    "name": {
      "fr": "Warpoquiche",
      "en": "Baked Cracker",
      "es": "Tarta salada de queso"
    },
    "required": 10,
    "familyId": 1015
  },
  {
    "id": "1144",
    "name": {
      "fr": "Smiley croquant",
      "en": "Ghost Toast",
      "es": "Smiley crujiente"
    },
    "required": 10,
    "familyId": 1016
  },
  {
    "id": "1145",
    "name": {
      "fr": "Barquette de lave",
      "en": "Flat Bread",
      "es": "Barquillo de lava"
    },
    "required": 10,
    "familyId": 1016
  },
  {
    "id": "1146",
    "name": {
      "fr": "Nonoix",
      "en": "Cracked Nut",
      "es": "Nonuez"
    },
    "required": 10,
    "familyId": 1016
  },
  {
    "id": "1147",
    "name": {
      "fr": "Amande croquante",
      "en": "Crunchy Almond",
      "es": "Almendra crujiente"
    },
    "required": 10,
    "familyId": 1016
  },
  {
    "id": "1148",
    "name": {
      "fr": "Noisette",
      "en": "Chestnut",
      "es": "Nuez"
    },
    "required": 10,
    "familyId": 1016
  },
  {
    "id": "1150",
    "name": {
      "fr": "Brioche vapeur",
      "en": "Steamed Brioche",
      "es": "Brioche de vapor"
    },
    "required": 10,
    "familyId": 1016
  },
  {
    "id": "1151",
    "name": {
      "fr": "Tartine chocolat-noisette",
      "en": "Slice of Chocolate Hazelnut Bread",
      "es": "Tostada con crema de chocolate"
    },
    "required": 10,
    "familyId": 1016
  },
  {
    "id": "1152",
    "name": {
      "fr": "Tartine hémoglobine",
      "en": "Slice of Raspberry Hazelnut Bread",
      "es": "Tostada con hemoglobina"
    },
    "required": 10,
    "familyId": 1016
  },
  {
    "id": "1153",
    "name": {
      "fr": "Tartine à l'orange collante",
      "en": "Slice of Sticky Orange Bread",
      "es": "Tostada de aceite"
    },
    "required": 10,
    "familyId": 1016
  },
  {
    "id": "1154",
    "name": {
      "fr": "Tartine au miel",
      "en": "Slice of Hard Honey Bread",
      "es": "Tostada de mermelada pegajosa"
    },
    "required": 10,
    "familyId": 1016
  },
  {
    "id": "1155",
    "name": {
      "fr": "Lombric nature",
      "en": "Earthworm",
      "es": "Lombriz al natural"
    },
    "required": 10,
    "familyId": 1016
  },
  {
    "id": "1159",
    "name": {
      "fr": "Blob périmé",
      "en": "Shiny Mushroom",
      "es": "Champiñón podrido"
    },
    "required": 10,
    "familyId": 1016
  },
  {
    "id": "1160",
    "name": {
      "fr": "Bonbon Hélène-fraiche",
      "en": "Peppermint Candy",
      "es": "Caramelo de reyes"
    },
    "required": 10,
    "familyId": 1016
  },
  {
    "id": "1058",
    "name": {
      "fr": "Canelé du sud-ouest",
      "en": "Hazelnut Chocolate",
      "es": "Canelé de Burdeos"
    },
    "required": 10,
    "familyId": 1017
  },
  {
    "id": "1059",
    "name": {
      "fr": "Eclair noisette choco caramel et sucre",
      "en": "Chocolate Eclair",
      "es": "Rebanada de pan con crema de cacao y avellana"
    },
    "required": 10,
    "familyId": 1017
  },
  {
    "id": "1072",
    "name": {
      "fr": "Arbuche de noël",
      "en": "Christmas Log",
      "es": "Tronco de Navidad"
    },
    "required": 10,
    "familyId": 1017
  },
  {
    "id": "1156",
    "name": {
      "fr": "Grenade de chantilly",
      "en": "Cream Grenade",
      "es": "Granada de crema"
    },
    "required": 10,
    "familyId": 1017
  },
  {
    "id": "1157",
    "name": {
      "fr": "Profies très drôles",
      "en": "Chocolate-Dipped Cream Puffs",
      "es": "Profiteroles apetitosos"
    },
    "required": 10,
    "familyId": 1017
  },
  {
    "id": "1158",
    "name": {
      "fr": "Chouchocos",
      "en": "Chocolate Delight",
      "es": "Megaprofiterol"
    },
    "required": 10,
    "familyId": 1017
  },
  {
    "id": "1165",
    "name": {
      "fr": "Tartelette framboise",
      "en": "Strawberry Tart",
      "es": "Tarta de frambuesa"
    },
    "required": 10,
    "familyId": 1017
  },
  {
    "id": "1170",
    "name": {
      "fr": "Transformer en sucre",
      "en": "Sugar Transformer",
      "es": "Transformer de azúcar"
    },
    "required": 10,
    "familyId": 1018
  },
  {
    "id": "1171",
    "name": {
      "fr": "Kitchissime",
      "en": "Evil Robot",
      "es": "Kitchisime"
    },
    "required": 10,
    "familyId": 1018
  },
  {
    "id": "1172",
    "name": {
      "fr": "Igorocop",
      "en": "RoboCop",
      "es": "Igorocop"
    },
    "required": 10,
    "familyId": 1018
  },
  {
    "id": "1173",
    "name": {
      "fr": "Tidouli didi",
      "en": "R2D2",
      "es": "Arto deedo"
    },
    "required": 10,
    "familyId": 1018
  },
  {
    "id": "1174",
    "name": {
      "fr": "Dalek ! Exterminate !",
      "en": "Dalek ! Exterminate !",
      "es": "¡Dalek, el Exterminador!"
    },
    "required": 10,
    "familyId": 1018
  },
  {
    "id": "1175",
    "name": {
      "fr": "Robo-malin",
      "en": "Robo-Malin",
      "es": "Robo-loco"
    },
    "required": 10,
    "familyId": 1018
  },
  {
    "id": "1176",
    "name": {
      "fr": "Johnny 6",
      "en": "Johnny 6",
      "es": "Johnny 6"
    },
    "required": 10,
    "familyId": 1018
  },
  {
    "id": "1177",
    "name": {
      "fr": "Biscuit Transformer",
      "en": "Biscuit Transformer",
      "es": "Galleta de Transformer"
    },
    "required": 10,
    "familyId": 1018
  },
  {
    "id": "1178",
    "name": {
      "fr": "Statue: Citron Sorbex",
      "en": "Statue: Sorbex Lemon",
      "es": "Estatua: Sorbetex de Limón"
    },
    "required": 10,
    "familyId": 1019
  },
  {
    "id": "1179",
    "name": {
      "fr": "Statue: Bombino",
      "en": "Statue: Bombino",
      "es": "Estatua: Bombino"
    },
    "required": 10,
    "familyId": 1019
  },
  {
    "id": "1180",
    "name": {
      "fr": "Statue: Poire Melbombe",
      "en": "Statue: Baddybomb Pear",
      "es": "Estatua: Pera Malabomba"
    },
    "required": 10,
    "familyId": 1019
  },
  {
    "id": "1181",
    "name": {
      "fr": "Statue: Tagada",
      "en": "Statue: Tagada-Strawberry",
      "es": "Estatua: Tagada"
    },
    "required": 10,
    "familyId": 1019
  },
  {
    "id": "1182",
    "name": {
      "fr": "Statue: Sapeur-kiwi",
      "en": "Statue: Kiwi Sapper",
      "es": "Estatua: Kiwi-Zapador"
    },
    "required": 10,
    "familyId": 1019
  },
  {
    "id": "1183",
    "name": {
      "fr": "Statue: Bondissante",
      "en": "Statue: Leaper",
      "es": "Estatua: Sandina"
    },
    "required": 10,
    "familyId": 1019
  },
  {
    "id": "1184",
    "name": {
      "fr": "Statue: Ananargeddon",
      "en": "Statue: Armaggedon-Pineapple",
      "es": "Estatua: Piñaguedón"
    },
    "required": 10,
    "familyId": 1019
  },
  {
    "id": "1190",
    "name": {
      "fr": "Passe-partout en bois",
      "en": "Wooden Master Key",
      "es": "Llave Maestra de Madera"
    },
    "required": 10,
    "familyId": 1020
  },
  {
    "id": "1191",
    "name": {
      "fr": "Clé de Rigor Dangerous",
      "en": "Rigor Dangerous Key",
      "es": "Llave de Rigor Dangerous"
    },
    "required": 10,
    "familyId": 1020
  },
  {
    "id": "1194",
    "name": {
      "fr": "Furtok Glaciale",
      "en": "Frozen Key",
      "es": "Furtok Glacial"
    },
    "required": 10,
    "familyId": 1020
  },
  {
    "id": "1197",
    "name": {
      "fr": "Clé des Mondes Ardus",
      "en": "Key of Difficult Worlds ",
      "es": "Llave de los Mundos Arduos"
    },
    "required": 10,
    "familyId": 1020
  },
  {
    "id": "1198",
    "name": {
      "fr": "Clé piquante",
      "en": "Pungent Key",
      "es": "Llave Que Rasca"
    },
    "required": 10,
    "familyId": 1020
  },
  {
    "id": "1199",
    "name": {
      "fr": "Passe-partout de Tuberculoz",
      "en": "Tuber's Key",
      "es": "Llave Maestra de Tubérculo"
    },
    "required": 10,
    "familyId": 1020
  },
  {
    "id": "1200",
    "name": {
      "fr": "Clé des cauchemars",
      "en": "Nightmare Key",
      "es": "Llave de las Pesadillas"
    },
    "required": 10,
    "familyId": 1020
  },
  {
    "id": "1193",
    "name": {
      "fr": "Clé du Bourru",
      "en": "Wine Key",
      "es": "Llave del Bruto"
    },
    "required": 1,
    "familyId": 1021
  },
  {
    "id": "1196",
    "name": {
      "fr": "Autorisation du Bois-Joli",
      "en": "Authorization of Bois-Joli",
      "es": "Autorización Madera-Bonita"
    },
    "required": 1,
    "familyId": 1022
  },
  {
    "id": "1192",
    "name": {
      "fr": "Méluzzine",
      "en": "Méluzzine Key",
      "es": "Meluzina"
    },
    "required": 10,
    "familyId": 1023
  },
  {
    "id": "1195",
    "name": {
      "fr": "Vieille clé rouillée",
      "en": "Old Rusty Key",
      "es": "Vieja Llave Oxidada"
    },
    "required": 10,
    "familyId": 1023
  },
  {
    "id": "1201",
    "name": {
      "fr": "Pad Sounie",
      "en": "Sony Controller",
      "es": "Mando Suni"
    },
    "required": 10,
    "familyId": 1024
  },
  {
    "id": "1202",
    "name": {
      "fr": "Pad Frusion 64",
      "en": "Nintendo 64 Controller",
      "es": "Mando Nientiendo 64"
    },
    "required": 10,
    "familyId": 1024
  },
  {
    "id": "1203",
    "name": {
      "fr": "Pad Game-Pyramid",
      "en": "Game-Cube Controller",
      "es": "Mando Game-Pirámide"
    },
    "required": 10,
    "familyId": 1024
  },
  {
    "id": "1204",
    "name": {
      "fr": "Pad Sey-Ga",
      "en": "Genesis Controller",
      "es": "Mando Sey-Ga"
    },
    "required": 10,
    "familyId": 1024
  },
  {
    "id": "1205",
    "name": {
      "fr": "Pad Super Frusion",
      "en": "SNES Controller",
      "es": "Mando Super Nientiendo"
    },
    "required": 10,
    "familyId": 1024
  },
  {
    "id": "1206",
    "name": {
      "fr": "Pad du Système Maitre",
      "en": "NES Controller",
      "es": "Mando del Sistema Maestro"
    },
    "required": 10,
    "familyId": 1024
  },
  {
    "id": "1207",
    "name": {
      "fr": "Pad Frusion Entertainment System",
      "en": "Master System Controller",
      "es": "Mando Nientiendo Entertainment System"
    },
    "required": 10,
    "familyId": 1024
  },
  {
    "id": "1208",
    "name": {
      "fr": "Manette S-Téhéf",
      "en": "Joystick",
      "es": "Mando S-Tehef"
    },
    "required": 10,
    "familyId": 1024
  },
  {
    "id": "1209",
    "name": {
      "fr": "Canette Express",
      "en": "Can Beer",
      "es": "Lata Express"
    },
    "required": 10,
    "familyId": 1025
  },
  {
    "id": "1210",
    "name": {
      "fr": "Bouteille aux 2064 bulles",
      "en": "Sealed Beer",
      "es": "Cerveza de las fiestas en Bordeaux"
    },
    "required": 10,
    "familyId": 1025
  },
  {
    "id": "1211",
    "name": {
      "fr": "Mousse volante",
      "en": "Draft Beer",
      "es": "Espuma voladora"
    },
    "required": 10,
    "familyId": 1025
  },
  {
    "id": "1212",
    "name": {
      "fr": "Vin Merveilleux",
      "en": "Wonderful Wine",
      "es": "Vino burgués del Gran Teatro"
    },
    "required": 10,
    "familyId": 1025
  },
  {
    "id": "1213",
    "name": {
      "fr": "Liqueur maléfique",
      "en": "Evil Liquor",
      "es": "Licor maléfico"
    },
    "required": 10,
    "familyId": 1025
  },
  {
    "id": "1214",
    "name": {
      "fr": "Tampon MT",
      "en": "MT Stamp",
      "es": "Sello MotionTwin"
    },
    "required": 10,
    "familyId": 1026
  },
  {
    "id": "1215",
    "name": {
      "fr": "Facture gratuite",
      "en": "Free Bill",
      "es": "Factura gratis"
    },
    "required": 10,
    "familyId": 1026
  },
  {
    "id": "1216",
    "name": {
      "fr": "Post-It de François",
      "en": "Sticky Notes",
      "es": "Post-It de François, no entiendo tu letra"
    },
    "required": 10,
    "familyId": 1026
  },
  {
    "id": "1217",
    "name": {
      "fr": "Pot à crayon solitaire",
      "en": "Pencil Container",
      "es": "Lapicero solitario sin pegatina de perro"
    },
    "required": 10,
    "familyId": 1026
  },
  {
    "id": "1218",
    "name": {
      "fr": "Agrafeuse du Chaos",
      "en": "Chaos Stapler",
      "es": "Grapadora del Caos"
    },
    "required": 10,
    "familyId": 1026
  },
  {
    "id": "1219",
    "name": {
      "fr": "Miroir bancal",
      "en": "Mirror of Bancal",
      "es": "Espejo de la cábala"
    },
    "required": 10,
    "familyId": 1027
  },
  {
    "id": "1220",
    "name": {
      "fr": "Etoile du Diable",
      "en": "Star of the Devil",
      "es": "Estrella demoníaca"
    },
    "required": 10,
    "familyId": 1027
  },
  {
    "id": "1225",
    "name": {
      "fr": "Miroir des Sables",
      "en": "Mirror of Sables",
      "es": "Espejo de las Arenas"
    },
    "required": 10,
    "familyId": 1027
  },
  {
    "id": "1226",
    "name": {
      "fr": "Etoile des Diables Jumeaux",
      "en": "Star of the Devil's Twins",
      "es": "Estrella de los Diablos Gemelos"
    },
    "required": 10,
    "familyId": 1027
  },
  {
    "id": "1227",
    "name": {
      "fr": "Sceau d'amitié",
      "en": "Mixed Heart",
      "es": "Sello de amistad"
    },
    "required": 10,
    "familyId": 1027
  },
  {
    "id": "1237",
    "name": {
      "fr": "Neige-o-glycérine",
      "en": "Snow Bomb",
      "es": "Nieve a la glicerina"
    },
    "required": 10,
    "familyId": 1027
  },
  {
    "id": "1238",
    "name": {
      "fr": "Pass-Pyramide",
      "en": "Pyramid Pass",
      "es": "Pase VIP Pirámide"
    },
    "required": 10,
    "familyId": 1027
  },
  {
    "id": "1221",
    "name": {
      "fr": "Poudre de plage magique",
      "en": "Shovel",
      "es": "Polvo de playa mágica"
    },
    "required": 5,
    "familyId": 1028
  },
  {
    "id": "1222",
    "name": {
      "fr": "Matériel d'architecte",
      "en": "Bucket of Sand",
      "es": "Material de arquitecto"
    },
    "required": 10,
    "familyId": 1028
  },
  {
    "id": "1223",
    "name": {
      "fr": "Maquette en sable",
      "en": "Sand Castle",
      "es": "Maqueta de arena"
    },
    "required": 5,
    "familyId": 1028
  },
  {
    "id": "1224",
    "name": {
      "fr": "Winkel",
      "en": "Winkel O'Riely",
      "es": "Wink"
    },
    "required": 3,
    "familyId": 1028
  },
  {
    "id": "1228",
    "name": {
      "fr": "Insigne de l'ordre des Ninjas",
      "en": "Symbol of the Ninjas",
      "es": "Insignia de la orden de los Ninjas"
    },
    "required": 10,
    "familyId": 1029
  },
  {
    "id": "1236",
    "name": {
      "fr": "Insigne du Mérite",
      "en": "Award of Merit",
      "es": "Insignia del Mérito"
    },
    "required": 10,
    "familyId": 1029
  },
  {
    "id": "1229",
    "name": {
      "fr": "Couteau suisse japonais",
      "en": "Magic Katana",
      "es": "Cuchillo suizo japonés"
    },
    "required": 10,
    "familyId": 1030
  },
  {
    "id": "1230",
    "name": {
      "fr": "Shuriken de second rang",
      "en": "Fuma Shuriken",
      "es": "Shuriken de segundo rango"
    },
    "required": 10,
    "familyId": 1030
  },
  {
    "id": "1231",
    "name": {
      "fr": "Shuriken d'entraînement",
      "en": "Shuriken",
      "es": "Shuriken de entrenamiento"
    },
    "required": 10,
    "familyId": 1030
  },
  {
    "id": "1232",
    "name": {
      "fr": "Najinata",
      "en": "Kunai",
      "es": "Najinata"
    },
    "required": 10,
    "familyId": 1030
  },
  {
    "id": "1233",
    "name": {
      "fr": "Lance-boulettes de Précision",
      "en": "Blowgun of Precision",
      "es": "Lanza-bolitas de Precisión"
    },
    "required": 10,
    "familyId": 1030
  },
  {
    "id": "1234",
    "name": {
      "fr": "Ocarina chantant",
      "en": "Singing Ocarina",
      "es": "Ocarina cantante"
    },
    "required": 10,
    "familyId": 1030
  },
  {
    "id": "1235",
    "name": {
      "fr": "Armure de la nuit",
      "en": "Armor of the Night",
      "es": "Casco samurai"
    },
    "required": 10,
    "familyId": 1030
  },
  {
    "//": "Custom item for Hammerfest Deluxe",
    "id": "1186",
    "name": {
      "fr": "Feuille de menthe",
      "en": "Mint Leaf",
      "es": "Hoja de Menta"
    },
    "unlock": 10,
    "familyId": 1031
  },
  {
    "//": "Custom item for Hammerfest Deluxe",
    "id": "1187",
    "name": {
      "fr": "Boîte Conservatrice",
      "en": "Storage Box",
      "es": "Caja Conservadora"
    },
    "unlock": 10,
    "familyId": 1031
  },
  {
    "//": "Custom item for Hammerfest Deluxe",
    "id": "1188",
    "name": {
      "fr": "Boisson Rafraîchissante",
      "en": "Refreshing Drink",
      "es": "Bebida Refrescante"
    },
    "unlock": 10,
    "familyId": 1031
  },
  {
    "//": "Custom item for Hammerfest Deluxe",
    "id": "1189",
    "name": {
      "fr": "Plateau Spécial Fromage De Migros",
      "en": "Migros Special Cheese Platter",
      "es": "Bandeja Especial de Queso de Migros"
    },
    "unlock": 10,
    "familyId": 1031
  }
]
